module.exports = __webpack_public_path__ + "img/member-orange.f58bfeda.svg";